var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 5.33333L8.66659 8.66666M17.9999 8.66666C16.758 7.44957 15.0859 6.77177 13.3471 6.78055C11.6082 6.78934 9.94306 7.48399 8.71349 8.71356C7.48391 9.94314 6.78926 11.6083 6.78048 13.3471C6.77169 15.086 7.44949 16.7581 8.66659 18M19.9999 6.66666L6.66659 20M18.6666 22.6667V22.68M13.3333 21.3333V21.3467M17.3333 17.3333V17.3467M21.3333 13.3333V13.3467M14.6666 26.6667V26.68M22.6666 18.6667V18.68M26.6666 14.6667V14.68",
    stroke: "#101828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShower);
export default __webpack_public_path__ + "static/media/shower.b6e38c85f8db354c4c8a3f56f72f5101.svg";
export { ForwardRef as ReactComponent };